<template>
  <div class="limits-detail col-md-4">
    <div class="limits-detail-header">
      <div class="limits-detail-logo">
        <img
          :src="paymentMethod.logoUrl"
          alt="Logo"
          width="32"
          height="32"
        >
      </div>
    </div>
    <div class="limits-detail-content">
      <div class="limits-detail-content-title">
        <bg-text
          type="body-md"
          weight="bold"
        >
          {{ paymentMethod.title }}
        </bg-text>
        <limits-card
          v-for="(limit, index) in limits.limits"
          :key="index"
          :limit="limit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BgText } from '@transfeeradev/bridge';
import LimitsCard from '@/apps/admin/limits/components/container/LimitsCard.vue';
import { paymentMethodDescriptions } from '@/apps/admin/limits/constants/paymentMethods';

export default {
  name: 'limits-detail',
  components: {
    LimitsCard,
    BgText
  },
  props: {
    limits: {
      type: Object,
      required: true
    }
  },
  computed: {
    paymentMethod() {
      return paymentMethodDescriptions[this.limits.paymentMethod];
    }
  }
};
</script>

<style scoped>
.limits-detail-header {
  display: flex;
  align-items: center;
  justify-content: center;
}
.limits-detail-logo {
  display: flex;
  background-color: var(--bg-green-semi-light);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: -8px;
  z-index: 1;
  position: relative;
}
.limits-detail-content {
  display: flex;
  width: 282px;
  padding: var(--bg-spacing-sm);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--bg-spacing-md);
  background-color: var(--bg-grey-white);
  border: 1px solid var(--bg-grey-light);
  border-radius: var(--bg-border-radius-md);
}
</style>